import React, { useState } from 'react';
import { Form, notification, Button as ANTButton, Switch } from 'antd';
import { Button } from 'components/Atom/Button';
import Select from 'components/Atom/Select';
import { useSelector, useDispatch } from 'react-redux';
import http from 'utils/http';
import { setStore } from 'app/features/userSlice';

const allowedRetriesOptions = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
];

const invoiceActionOptions = [
  { label: 'Open', value: 'open' },
  { label: 'Draft', value: 'draft' },
  { label: 'Paid', value: 'paid' },
];

const subscriptionActionOptions = [
  { label: 'Paid', value: 'paid' },
  { label: 'Inactive', value: 'inactive' },
  { label: 'Paused', value: 'paused' },
  { label: 'Cancelled', value: 'cancelled' },
];

export const EditSubscription = ({ handleOpen, updateState, store }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const selectedStore = useSelector((state) => state?.company?.store);
  const userStores = useSelector((state) => state?.company?.userStores);
  const subscription = store?.subscription || {};

  const initialValues = {
    allowed_retries: subscription?.allowed_retries,
    invoice_action: subscription?.invoice_action,
    subscription_action: subscription?.subscription_action,
    send_payment_link_on_inactive: subscription?.send_payment_link_on_inactive ?? false,
    send_subscription_payment_email: subscription?.send_subscription_payment_email ?? true,
    allow_past_due_cancel: subscription?.allow_past_due_cancel ?? false,
    allow_past_due_pause: subscription?.allow_past_due_pause ?? false,
    allow_past_due_skip: subscription?.allow_past_due_skip ?? false,
  };

  const onSubmit = async (values) => {
    if (userStores?.length > 1 && !selectedStore?.isSelected) {
      notification.error({ message: 'Select store from the drop-down menu above', placement: 'bottomRight' });
      return;
    }

    setLoading(true);
    try {
      const { allow_past_due_cancel, allow_past_due_pause, allow_past_due_skip, send_payment_link_on_inactive, send_subscription_payment_email, allowed_retries, invoice_action, subscription_action } = values;
      const payload = {
        subscription: {
          allow_past_due_cancel,
          allow_past_due_pause,
          allow_past_due_skip,
          send_payment_link_on_inactive,
          send_subscription_payment_email,
          allowed_retries: allowed_retries,
          invoice_action: invoice_action,
          subscription_action: subscription_action,
        },
      };

      const res = await http.put(`/stores/${store?._id || selectedStore?._id}`, payload);
      if (res?.data?.success) {
        notification.success({ message: 'Subscription settings updated successfully', placement: 'bottomRight' });
        dispatch(setStore({ ...res?.data?.data, isSelected: selectedStore?.isSelected }));
        updateState();
        handleOpen();
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      notification.error({ message: err?.response?.data?.message || 'Failed to update subscription settings', placement: 'bottomRight' });
    }
  };

  return (
    <Form layout='vertical' initialValues={initialValues} onFinish={onSubmit} method='post'>
      <Form.Item name='allowed_retries' label='Number of Retries on Payment Failure (Up to 6 allowed)' className='modal-field' rules={[{ required: true, message: 'Retry is Required' }]}>
        <Select optionsValue={allowedRetriesOptions} labelInValue={false} placeholder='Select allowed retries' />
      </Form.Item>

      <Form.Item name='invoice_action' label='Invoice Action on Subscription Payment Failure' className='modal-field' rules={[{ required: true, message: 'Invoice Action is Required' }]}>
        <Select optionsValue={invoiceActionOptions} labelInValue={false} placeholder='Select Invoice Action' />
      </Form.Item>

      <Form.Item name='subscription_action' label='Subscription Action on Payment Failure' className='modal-field' rules={[{ required: true, message: 'Subscription Action is Required' }]}>
        <Select optionsValue={subscriptionActionOptions} labelInValue={false} placeholder='Select Subscription Action' />
      </Form.Item>

      <Form.Item name='send_payment_link_on_inactive' label='Send Payment Link if Subscription Payment Fails' valuePropName='checked' className='modal-field'>
        <Switch />
      </Form.Item>

      <Form.Item name='send_subscription_payment_email' label='Send Subscription Payment Email' valuePropName='checked' className='modal-field'>
        <Switch />
      </Form.Item>

      <div className='past-due-actions' style={{ marginBottom: 16 }}>
        <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 12, color: '#262626' }}>Allow Subscription Action on Past-Due Payment</div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }}>
          <Form.Item name='allow_past_due_cancel' label='Cancel' valuePropName='checked' className='modal-field' style={{ marginBottom: 0 }}>
            <Switch />
          </Form.Item>
          <Form.Item name='allow_past_due_pause' label='Pause' valuePropName='checked' className='modal-field' style={{ marginBottom: 0 }}>
            <Switch />
          </Form.Item>
          <Form.Item name='allow_past_due_skip' label='Skip' valuePropName='checked' className='modal-field' style={{ marginBottom: 0 }}>
            <Switch />
          </Form.Item>
        </div>
      </div>

      <Form.Item>
        <div className='flex justify-end gap-2'>
          <ANTButton className='rounded-lg' block onClick={() => handleOpen()} disabled={loading}>
            Cancel
          </ANTButton>
          <Button type='primary' block className='primaryBtn ml-4' htmlType='submit' loading={loading}>
            {store?.subscription ? 'Update' : 'Add'}
          </Button>
        </div>
      </Form.Item>
    </Form>
  );
};
